import React, { useMemo } from 'react';
import CommonTable from '@/pages/dashboard/components/CommonTable';
import { ICommonBaseTableRef } from '@home/components/CommonBaseTable/_type';

interface ITableWithDateSubtitleProps {
  data?: Record<string, unknown>;
  metricsCardWrapProps?: Record<string, unknown>;
  [key: string]: unknown;
}

const TableWithDateSubtitle = React.forwardRef<ICommonBaseTableRef, ITableWithDateSubtitleProps>(
  (props, ref) => {
    const { data, metricsCardWrapProps, ...restProps } = props;

    const mergedMetricsCardWrapProps = useMemo(() => {
      const subtitleEn = (data?.__dateRangeSubtitleEn__ as string) || '';
      const subtitleCn = (data?.__dateRangeSubtitleCn__ as string) || '';
      return {
        ...metricsCardWrapProps,
        subtitleEn: subtitleEn || metricsCardWrapProps?.subtitleEn,
        subtitleCn: subtitleCn || metricsCardWrapProps?.subtitleCn,
      };
    }, [metricsCardWrapProps, data?.__dateRangeSubtitleEn__, data?.__dateRangeSubtitleCn__]);

    return (
      <CommonTable
        ref={ref}
        {...restProps}
        data={data}
        metricsCardWrapProps={mergedMetricsCardWrapProps}
      />
    );
  },
);

TableWithDateSubtitle.displayName = 'TableWithDateSubtitle';

export default TableWithDateSubtitle;
